import { Result, ResultProps } from 'antd';
import { useRouteError } from 'react-router-dom';
import { ButtonWizard } from '..';
import { RefreshCcw } from 'lucide-react';

interface NotFoundProps {
  config?: ResultProps;
}

const DEFAULT_CONFIG: ResultProps = {
  status: '404',
  title: '404',
  subTitle: 'Sorry, the page you visited does not exist.',
};

export default function NotFound({ config }: NotFoundProps) {
  const error = useRouteError();

  let finalConfig = {};
  if (!config || !Object.keys(config).length) finalConfig = DEFAULT_CONFIG;
  if (error && typeof error === 'object' && 'message' in error) {
    finalConfig = {
      status: '500',
      title: error.message,
      subTitle: 'Internal Error',
    };
  }

  function handleReloadClick() {
    sessionStorage.removeItem('redirected');
    // Clear the session storage to avoid infinite loop of redirects
    window.location.reload();
  }
  return (
    <Result
      {...finalConfig}
      extra={
        <ButtonWizard
          onBtnClick={handleReloadClick}
          addOnClass="bg-info-600"
          addOnTextClass="text-white"
          buttonText="Reload"
        >
          <RefreshCcw className="size-4 stroke-[2px] text-white" />
        </ButtonWizard>
      }
    />
  );
}
